// Angular core
import { Component, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Router, RouterLink } from '@angular/router';

// Angular Forms
import {
  ReactiveFormsModule,
  FormBuilder,
  FormGroup,
  Validators,
} from '@angular/forms';

// Angular Material
import { MatButtonModule } from '@angular/material/button';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';
import { MatSnackBar } from '@angular/material/snack-bar';

// Third-party libraries
import { QuillModule } from 'ngx-quill';

// Local services
import { LoaderService } from '../../../shared/services/loader/loader.service';
import { NewsService } from '../../../shared/services/news/news.service';
import { QuillConfigService } from '../../../shared/services/quill-config.service';
import { RolesService } from '../../../shared/services/roles/roles.service';
import { StorageService } from '../../../shared/services/storage/storage.service';

// Local components
import { LoaderComponent } from '../../../shared/components/loader/loader.component';

@Component({
  selector: 'app-add-mail',
  imports: [
    CommonModule,
    RouterLink,
    ReactiveFormsModule,
    MatButtonModule,
    MatFormFieldModule,
    MatIconModule,
    MatInputModule,
    MatSelectModule,
    QuillModule,
    LoaderComponent,
  ],
  templateUrl: './add-mail.component.html',
  styleUrls: ['./add-mail.component.css', '../../../shared/styles/layout.css'],
})
export class AddMailComponent {
  modules: any;
  myroles: any = {};

  element: any = null;
  mailForm: FormGroup;
  toppingList: string[] = ['Iniciada', 'En trámite', 'Aceptada', 'Declinada'];
  typesList: string[] = ['Sugerencia', 'Queja', 'Felicitación'];

  constructor(
    private newsService: NewsService,
    private router: Router,
    private fb: FormBuilder,
    private loaderService: LoaderService,
    private quillConfigService: QuillConfigService,
    private storageService: StorageService,
    private rolesService: RolesService
  ) {
    this.modules = this.quillConfigService.getDefaultModules();
    this.mailForm = this.fb.group({
      title: ['', [Validators.required]],
      observation: ['', [Validators.required]],
      toppings: ['', [Validators.required]],
      type: ['', [Validators.required]],
    });
  }

  get isLoading() {
    return this.loaderService.getLoader();
  }

  private _snackBar = inject(MatSnackBar);
  // Función para mostrar un snackbar
  openSnackBar(message: string) {
    this._snackBar.open(message, 'Cerrar', {
      duration: 5000,
    });
  }

  loadRoles() {
    // Get permissions using the service method
    const permissions = this.rolesService.getPermissionsForFunctionality(
      'inbox',
      this.storageService
    );

    if (permissions) {
      // Store permissions in myroles
      this.myroles = permissions;

      // Check write permission and redirect if needed
      this.rolesService.checkWritePermission(
        'inbox',
        this.storageService,
        this._snackBar,
        this.router,
        '/home/communication/mailbox',
        'No tienes permisos para añadir una consulta'
      );
    } else {
      // console.log('No user roles found in storage');
    }
  }

  ngOnInit() {
    this.loadRoles();
  }

  saveChanges() {
    this.loaderService.showLoader();
    if (this.mailForm.invalid) {
      // Mark all controls as touched to trigger validation visuals
      Object.keys(this.mailForm.controls).forEach((key) => {
        const control = this.mailForm.get(key);
        control?.markAsTouched();
      });

      this.loaderService.hideLoader();

      this.openSnackBar('Por favor complete todos los campos requeridos');
      return;
    }

    const formValues = this.mailForm.value;

    // Prefer the HTML content from Quill editor when available (preserves emojis)
    let content = formValues.observation;
    try {
      const quillEditor = document.querySelector('.ql-editor') as HTMLElement;
      if (quillEditor && quillEditor.innerHTML) {
        content = quillEditor.innerHTML;
        // console.log('Using HTML content from Quill editor to preserve emojis');
      }
    } catch (err) {
      // ignore and fallback to form value
    }

    this.newsService
      .postSuggestion({
        title: formValues.title,
        content: content,
        status: formValues.toppings,
        types: formValues.type,
      })
      .subscribe({
        next: (response) => {
          // console.log('Response:', response);
          this.loaderService.hideLoader();
          this.openSnackBar('Actividad creada con éxito.');
          this.router.navigate(['/home/communication/mailbox']);
        },
        error: (error) => {
          this.loaderService.hideLoader();
          console.error('There was an error!', error);
          this.openSnackBar('Error al crear la actividad. Inténtalo de nuevo.');
          // this.router.navigate(['/home/communication/mailbox']);
        },
      });
  }
}
